import type { NextBlock } from 'src/redux/types';
import { usePickBlock } from 'src/utils/pick-block';
import type { BlockElement } from './core/type';
import { BlockType } from '@next-space/fe-api-idl';

const renderers = new Map<NextBlock['type'], BlockElement>();

const UnSupported: BlockElement = ({ id }) => {
  const block = usePickBlock(id, []);
  // 非开发环境不显示未支持，可能会有虚拟列表报错的情况，需要有个dom
  if (!__HOST_LOCAL__) return <div className="h-px" />;
  if (block?.type === BlockType.TABLE_ROW) {
    return null;
  }

  return (
    <div className="text-grey4 p-2">
      未支持的块类型 <sup>[{block?.type}]</sup>
    </div>
  );
};

export const _setRenderer = (type: NextBlock['type'], Element: BlockElement) => {
  renderers.set(type, Element);
};

export const getBlockRenderer = (type?: NextBlock['type']) => {
  if (type == null) return UnSupported;
  return renderers.get(type) ?? UnSupported;
};
